import { useId } from 'react';
import { Checkbox as BaseCheckbox } from '@base-ui/react/checkbox';
import { Check, Minus } from 'lucide-react';
import Icon from './Icon.jsx';

/** A checkbox with its label; the whole row is clickable. Supports `indeterminate`. */
const Checkbox = ({ label, description, checked, defaultChecked, indeterminate = false, onCheckedChange, disabled = false }) => {
  const id = useId();

  return (
    <div className="comp-checkbox" data-disabled={disabled ? 'true' : undefined}>
      <BaseCheckbox.Root id={id} className="comp-checkbox__box" checked={checked} defaultChecked={defaultChecked} indeterminate={indeterminate} onCheckedChange={onCheckedChange} disabled={disabled} aria-describedby={description ? `${id}-description` : undefined}>
        <BaseCheckbox.Indicator className="comp-checkbox__indicator">
          <Icon icon={indeterminate ? Minus : Check} size="sm" />
        </BaseCheckbox.Indicator>
      </BaseCheckbox.Root>
      <div className="comp-checkbox__text">
        <label htmlFor={id} className="comp-checkbox__label">
          {label}
        </label>
        {description && (
          <p className="comp-checkbox__description" id={`${id}-description`}>
            {description}
          </p>
        )}
      </div>
    </div>
  );
};

export default Checkbox;
